/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Gate_Action_GenerateInputs */

const en_common_auth_gate_action_generate = /** @type {(inputs: Common_Auth_Gate_Action_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`make your video`)
};

const zh_common_auth_gate_action_generate = /** @type {(inputs: Common_Auth_Gate_Action_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成视频`)
};

/**
* | output |
* | --- |
* | "make your video" |
*
* @param {Common_Auth_Gate_Action_GenerateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_gate_action_generate = /** @type {((inputs?: Common_Auth_Gate_Action_GenerateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Gate_Action_GenerateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_gate_action_generate(inputs)
	return zh_common_auth_gate_action_generate(inputs)
});
export { common_auth_gate_action_generate as "common.auth.gate.action.generate" }